export const sorensonSipVersion = '5';
